/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingGroupsVisitGroupIdQueryResponse, GetApiBookingGroupsVisitGroupIdPathParams, GetApiBookingGroupsVisitGroupIdQueryParams, GetApiBookingGroupsVisitGroupId403, GetApiBookingGroupsVisitGroupId404, GetApiBookingGroupsVisitGroupId500 } from "../entities/GetApiBookingGroupsVisitGroupId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBookingGroupsVisitGroupId } from "../api/getApiBookingGroupsVisitGroupId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBookingGroupsVisitGroupIdQueryKey = (visit_group_id: GetApiBookingGroupsVisitGroupIdPathParams["visit_group_id"] | undefined, params: GetApiBookingGroupsVisitGroupIdQueryParams) => [{ url: '/api/booking-groups/:visit_group_id', params: {visit_group_id:visit_group_id} }, ...(params ? [params] : [])] as const

export type GetApiBookingGroupsVisitGroupIdQueryKey = ReturnType<typeof getApiBookingGroupsVisitGroupIdQueryKey>

export function getApiBookingGroupsVisitGroupIdQueryOptions(visit_group_id: GetApiBookingGroupsVisitGroupIdPathParams["visit_group_id"] | undefined, params: GetApiBookingGroupsVisitGroupIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBookingGroupsVisitGroupIdQueryKey(visit_group_id, params)
        return queryOptions<GetApiBookingGroupsVisitGroupIdQueryResponse, ResponseErrorConfig<GetApiBookingGroupsVisitGroupId403 | GetApiBookingGroupsVisitGroupId404 | GetApiBookingGroupsVisitGroupId500>, GetApiBookingGroupsVisitGroupIdQueryResponse, typeof queryKey>({
         enabled: !!(visit_group_id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBookingGroupsVisitGroupId(visit_group_id!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает резерв до оплаты, подтверждённую запись после оплаты или истёкший резерв
 * @summary Получить состояние веб-брони
 * {@link /api/booking-groups/:visit_group_id}
 */
export function useGetApiBookingGroupsVisitGroupId<TData = GetApiBookingGroupsVisitGroupIdQueryResponse, TQueryData = GetApiBookingGroupsVisitGroupIdQueryResponse, TQueryKey extends QueryKey = GetApiBookingGroupsVisitGroupIdQueryKey>(visit_group_id: GetApiBookingGroupsVisitGroupIdPathParams["visit_group_id"] | undefined, params: GetApiBookingGroupsVisitGroupIdQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBookingGroupsVisitGroupIdQueryResponse, ResponseErrorConfig<GetApiBookingGroupsVisitGroupId403 | GetApiBookingGroupsVisitGroupId404 | GetApiBookingGroupsVisitGroupId500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBookingGroupsVisitGroupIdQueryKey(visit_group_id, params)
         

         const query = useQuery({
          ...getApiBookingGroupsVisitGroupIdQueryOptions(visit_group_id, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBookingGroupsVisitGroupId403 | GetApiBookingGroupsVisitGroupId404 | GetApiBookingGroupsVisitGroupId500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}